type WeekHours = { weekdays: string | null; saturday: string | null; sunday: string | null };

const RANGE = /(\d{1,2}):(\d{2})\D+(\d{1,2}):(\d{2})/;

/** The weekday and the minute of the day at `now`, read in the studio's time zone. */
const clock = (now: Date, timeZone?: string) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
    timeZone,
  }).formatToParts(now);
  const read = (type: string) => parts.find((part) => part.type === type)?.value ?? "";
  return { weekday: read("weekday"), minutes: Number(read("hour")) * 60 + Number(read("minute")) };
};

/**
 * The closing time ("19:00") when the studio is open at `now`, otherwise `null`. Hours are the
 * strings from the trainer's own `hours` ("8:00 to 19:00"); a line it cannot read counts as closed, so
 * the site never claims to be open on a guess.
 */
export const openUntil = (hours: WeekHours, now: Date, timeZone?: string) => {
  const { weekday, minutes } = clock(now, timeZone);
  const today = weekday === "Sat" ? hours.saturday : weekday === "Sun" ? hours.sunday : hours.weekdays;
  const match = today ? RANGE.exec(today) : null;
  if (!match) return null;

  const [, fromHour, fromMinute, toHour, toMinute] = match;
  const opens = Number(fromHour) * 60 + Number(fromMinute);
  const closes = Number(toHour) * 60 + Number(toMinute);
  return minutes >= opens && minutes < closes ? `${toHour}:${toMinute}` : null;
};
